import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import styles from './NavBar.module.css'

export function NavBar() {
  const { logout, role, email, plan, planExpiresAt, isSuperAdmin } = useAuth()
  const location = useLocation()

  const isActive = (path: string) =>
    location.pathname === path || location.pathname.startsWith(path + '/')

  const planExpired = planExpiresAt
    ? new Date(planExpiresAt) < new Date()
    : false

  return (
    <nav className={styles.nav}>

      {/* BRAND */}
      <div className={styles.brand}>
        <span className={styles.logo}>AC</span>
        <span className={styles.title}>Facebook CampaignOS</span>
      </div>

      {/* LINKS */}
      <div className={styles.links}>

        <Link
          to="/dashboard"
          className={`${styles.link} ${location.pathname === '/dashboard' ? styles.active : ''}`}
        >
          Overview
        </Link>

        <Link
          to="/dashboard/create-campaign"
          className={`${styles.link} ${isActive('/dashboard/create-campaign') ? styles.active : ''}`}
        >
          Create
        </Link>

        <Link
          to="/dashboard/campaigns"
          className={`${styles.link} ${isActive('/dashboard/campaigns') ? styles.active : ''}`}
        >
          Ad Campaigns
        </Link>

        <Link
          to="/dashboard/analytics"
          className={`${styles.link} ${isActive('/dashboard/analytics') ? styles.active : ''}`}
        >
          Analytics
        </Link>

        <Link
          to="/dashboard/alerts"
          className={`${styles.link} ${isActive('/dashboard/alerts') ? styles.active : ''}`}
        >
          Alerts
        </Link>

        <Link
          to="/settings"
          className={`${styles.link} ${isActive('/settings') ? styles.active : ''}`}
        >
          Settings
        </Link>

        {isSuperAdmin && (
          <Link
            to="/admin"
            className={`${styles.link} ${isActive('/admin') ? styles.active : ''}`}
          >
            Admin
          </Link>
        )}

      </div>

      {/* USER SECTION */}
      <div className={styles.user}>

        <span className={styles.roleTag} data-role={role}>
          {role}
        </span>

        <span
          className={styles.roleTag}
          data-role={planExpired ? 'expired' : plan ?? 'free'}
          title={planExpiresAt ? `Expires: ${new Date(planExpiresAt).toLocaleDateString()}` : ''}
        >
          {planExpired ? 'expired' : (plan ?? 'free')}
        </span>

        {email && (
          <span className={styles.email}>
            {email}
          </span>
        )}

        <button className={styles.logoutBtn} onClick={logout}>
          Logout
        </button>

      </div>

    </nav>
  )
}
